const ONE_TO_ONE = 'ONE_TO_ONE';
const isActive = ({
  active
}) => active === true;
const isOneToOne = ({
  internalName
}) => internalName === ONE_TO_ONE;
const byOrder = (a, b) => a.order - b.order;
const getDefaultSubscriptionId = subscriptionDefinitions => {
  const activeSubscriptions = subscriptionDefinitions.sort(byOrder).filter(isActive);
  const oneToOneSubscription = activeSubscriptions.find(isOneToOne);
  const {
    id
  } = oneToOneSubscription || activeSubscriptions[0] || {};
  return id;
};
export default getDefaultSubscriptionId;